const variantClasses = {
  primary:
    "inline-flex items-center gap-2 bg-grad-coral text-white px-7 py-4 rounded-full font-semibold text-[15.5px] shadow-btn hover:shadow-btn-hover hover:-translate-y-0.5 transition-all duration-300 no-underline",
  soft: "inline-flex items-center gap-2.5 bg-white text-ink px-6 py-4 rounded-full font-medium text-[15.5px] shadow-card hover:shadow-card-hover hover:text-cerulean hover:-translate-y-0.5 border border-line transition-all duration-300 no-underline",
  signup:
    "inline-flex items-center gap-1.5 bg-grad-blue text-white px-5 py-2.5 rounded-full font-semibold text-sm shadow-blue hover:shadow-blue-hover hover:-translate-y-0.5 transition-all duration-300 no-underline",
  ghost:
    "inline-flex items-center text-ink-soft hover:text-cerulean hover:bg-ice px-4 py-2.5 rounded-full font-medium text-sm transition-all duration-200 no-underline",
  cta: "inline-flex items-center gap-2 bg-grad-coral text-white px-8 py-4 rounded-full font-semibold text-base shadow-btn hover:shadow-btn-hover hover:-translate-y-0.5 transition-all duration-300 no-underline",
};

/**
 * Anchor-rendered button with variant styling matching the homepage design system.
 *
 * @param {Object} props
 * @param {"primary" | "soft" | "signup" | "ghost" | "cta"} props.variant - visual variant
 * @param {string} props.href - destination URL or in-page anchor
 * @param {import("react").ReactNode} props.children - button label content
 * @param {import("react").ReactNode} [props.icon] - optional icon element
 * @param {"leading" | "trailing"} [props.iconPosition] - icon placement, defaults to trailing
 * @param {string} [props.className] - extra classes appended to variant classes
 * @param {(event: import("react").MouseEvent) => void} [props.onClick] - click handler
 * @returns {import("react").ReactElement}
 */
export function Button(props) {
  const {
    variant,
    href,
    children,
    icon,
    iconPosition = "trailing",
    className = "",
    onClick,
  } = props;

  const classes = `${variantClasses[variant]} ${className}`.trim();

  return (
    <a className={classes} href={href} onClick={onClick}>
      {icon && iconPosition === "leading" ? icon : null}
      <span>{children}</span>
      {icon && iconPosition === "trailing" ? icon : null}
    </a>
  );
}
